/**
 * 　(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 　CONFIDENTIAL / 社外秘
 * 　無断開示・無断複製禁止
 */
/**
 * ヘッダー定義用コンポーネント
 */
<template>
	<div class="header">
		<div class="top-menu">
			<!-- Left -->
			<!-- @Labelplusロゴ -->
			<div class="logo">
				<a style="cursor: pointer;" @click="onJump(url_menu)">
					<img v-once :src="getRootPath('img/head_logo.png')" loading="lazy">
				</a>
			</div>
			<!-- Right -->
			<div v-if="setting_param" class="login">
				<div class="login-area">
					<!-- 未ログイン -->
					<div v-if="!is_login" class="nav navbar-nav navbar-right">
						<a  v-bind:href="url_login" >
							{{r_messages.label_login}}
						</a>
						<!-- <a v-bind:href="url_register">
							{{r_messages.label_register}}
						</a> -->
					</div>
					<!-- ログイン中 -->
					<div v-if="is_login" class="login-state-area" :class="{'login-state-area-user': r_settings.user.is_client != 0, 'login-state-area-admin': r_settings.user.is_client == 0}">
						<!-- <span class="login-state" style="cursor: pointer;" @click="onBtnUserSelect">{{r_messages.label_login_prefix}} {{user_name}}</span> -->
						<!-- <span class="login-state">{{r_messages.label_login_prefix}}&nbsp;:&nbsp;{{user_name}}</span> -->
						<span class="login-state">
              <span :style="setElementStyle('logging_in')" @click="changeDispLanguage()">{{r_messages.label_login_prefix}}&nbsp;:&nbsp;</span>
              <span :class="getAddInputClass('user_id', r_settings.user)">{{user_id}}</span>
            </span>
						<span class="login-state-table">
							<!-- <span>{{r_messages.label_login_seller}} : {{user_name}}</span>
							<br>
							<span>{{r_messages.label_login_dealer}} : {{user_name}}</span> -->
							<table>
								<tbody>
									<tr>
										<td>{{r_messages.label_login_seller}}</td>
										<td>&nbsp;:&nbsp;</td>
										<td v-html="dispSellerName(r_settings.user.seller_name)"></td>
									</tr>
									<tr>
										<td>{{r_messages.label_login_dealer}}</td>
										<td>&nbsp;:&nbsp;</td>
										<td v-html="dispDealerName(r_settings.user.dealer_name)"></td>
									</tr>
								</tbody>
							</table>
						</span>
					</div>
					<div v-if="is_login" class="nav functions">
						<!-- 企業選択 -->
						<!-- <span v-if="r_settings.user.is_client==0" class="select-company">
							<a style="cursor: pointer;" @click="onBtnSelect">
								<img :src="getRootPath('img/icon_company.png')" class="icon">
								{{r_messages.label_select_company}}
							</a>
						</span> -->
						<!-- ヘルプ（新しいタブで開くので右クリック系も許可する） -->
						<!-- <span class="help">
							<a :href="url_help" :target="target_blank">
								<img :src="getRootPath('img/icon_help.png')" class="icon">
								{{r_messages.label_help}}
							</a>
						</span> -->
						<!--ログアウト -->
						<span class="logout">
							<a style="cursor: pointer;" @click="onLogout">
								<!-- <img :src="getRootPath('img/icon_logout.png')" class="icon"> -->
								<!-- {{r_messages.label_logout}} -->
								<i class="btn-logout fa-solid fa-right-from-bracket"></i>
							</a>
						</span>
						<form id="logout-form" v-bind:action="getRootPath('logout')" method="POST" style="display: none;">
							<input type="hidden" name="_token" v-bind:value="csrf_token" />
						</form>
					</div>
				</div>
			</div>
			<!--企業選択レイヤ -->
			<!-- <div v-if="m_selectCompany">
				<c-viewdialog r_dragid="choice" :r_title="r_messages.label_select_company" @event_cancel="onButClose()">
					<div slot="content">
						<slot>
							!-- 単一選択画面 --
							<c-wndselectone
								:r_type="manager.COMPANY_URL_TYPE"
								:r_param="{'including_admin':1}"
								:r_info="{}"
								:r_messages="r_messages"
								:r_settings="r_settings"
								:r_code="m_nCompanyCode"
								@event_change="onChangeCompany"
							>
							</c-wndselectone>
						</slot>
					</div>
				</c-viewdialog>
			</div> -->
			<!-- ユーザー設定レイヤ -->
			<!-- <div v-if="m_selectUser">
				<c-viewdetail-user
					class='viewdetail-user'
					r_comp_viewparam="c-user-viewparam"
					r_comp_funcdetail="c-funcdetail-user"
					:r_is_first="true"
					:r_messages = "user_messages"
					:r_settings = "user_settings"
					:r_info="m_userInfo"
					:r_is_new="false"
					:r_class_code="2"
					:r_detail_sub_title="{}"
					:r_is_previous_next_btn="false"
					:r_header_disp="true"
					@event_close="onBtnUserClose"
				>
				</c-viewdetail-user>
			</div> -->
			<div class="clearfix" />
		</div>
		<div class="dd-menu">
			<!-- 2段目 -->
			<div v-if="m_objDisp">
				<ul id="menu-normal" class="dropmenu" :class="{'menu-smartphone':is_smart_phone}">
					<li class="disp" v-bind:class="getMenuClass(menu)" v-for="(menu,key) in m_objDisp" @click="onMenuClick(menu)" >
						<!-- URL リンク -->
						<a class="menu" v-if="menu.url" @click="onJump('.' + menu.url)">
							<div class="menu-home">
								{{menu.title}}
							</div>
						</a>
						<!-- ドロップダウンメニュー -->
						<span v-else  :class="{'stable-disp':m_bDispStable && m_strDispStable == menu.title, 
												'stable-hide':m_bDispStable && m_strDispStable != menu.title}">
							<span v-bind:class="{'drop-item': isUsedSubMenu(menu), 'drop-no-item': !isUsedSubMenu(menu)}">{{menu.title}}</span>
							<!-- ドロップマーク -->
							<div v-if="isUsedSubMenu(menu)">
								<div v-if="!is_smart_phone">
									<img class="dropmark" v-if="m_strDispStable == menu.title" :class="{'dropmark-stable':m_strDispStable == menu.title}" :src="getRootPath('img/dropmark_select.png')">
									<img class="dropmark" v-else :class="{'dropmark-stable':m_strDispStable == menu.title}" :src="getRootPath('img/dropmark.png')">
								</div>
								<div v-else>
									<img v-if="isUsedSubMenu(menu)" class="dropmark" :src="getRootPath('img/dropmark_select.png')">
								</div>
							</div>
							<!-- ドロップメニュー -->
							<div 
								v-if="isUsedSubMenu(menu)"
								class="sub-menu"
								:class="{'sub-menu-display':m_bDispStable && m_strDispStable==menu.title}"
								v-bind:style="{position:'absolute', left:getMenuLeft(key) , width:getMenuWidth() }">
								<div class="content">
									<!-- アイテム -->
									<div class="content-item" v-if="menu.list[0].type == 'item'">
										<ul>
											<a v-for="item in menu.list"
												style="cursor: pointer;" @click="onJump('.'+item.url)">
												<li>
													<div class="menu-item">{{item.title}}</div>
												</li>
											</a>
										</ul>
									</div>
									<!-- カテゴリ -->
									<div v-else class="content-category">
										<!-- カテゴリ下のアイテム表示 -->
										<ul>
											<li v-for="cat in menu.list">
												<span class="text-category">{{cat.title}}</span>
												<div class="content-item" :class="addMenuItemClass(menu, cat.title)">
													<ul>
														<a v-for="item in cat.list"
															style="cursor: pointer;" @click="onJump('.'+item.url)">
															<li >
																<div class="menu-item">{{item.title}}</div>
															</li>
														</a>
													</ul>
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</span>
						<div class="partition-r"></div>
					</li>
				</ul>
				<div class="drop">

				</div>
			<div class="clearfix" />
			</div>
	</div>
</div>
</template>
<script>
	import {DISPLAY_URL} from 'js/const/constants';
	import {USER_TYPE} from 'js/const/constants';

	const INCLUDING_ADMIN = 1;
	/**
	 * 入力制限数値.
	 * @module js\parts_unit\Header
	 * @param {string[]} value - Disabled component
	 * @param {number} max_length - Required, need two way
	 */
	export default {
		mixins:[
			require('js/common/url.mixin.vue'),

			// setting
			require('js/common/vuex/setting/read.mixin.vue'),
			// マネージャーインスタンスアクセス
			require('js/common/vuex/manager/read.mixin.vue'),
			//! 企業選択
			require('js/common/select/company.mixin.vue'),

		],
		props:[
			'r_messages',
			'r_header',
			'r_jump_callback',
			'r_settings',
		],
		created: function() {
			this.m_nCompanyName = this.r_settings.user.company_name;
			this.m_nCompanyCode = this.r_settings.user.company_code;
		},
		data() {
			return {
				m_objDisp: {},//!< 表示用アイテム
				// 表示固定モード
				m_bDispStable:false,
				m_strDispStable:"",
				m_timeStableStart:null, //固定表示開始時間
				m_selectCompany:false,
				m_selectUser:false,		// ユーザー画面の選択
				m_userInfo:{},			// ユーザー情報
			};
		},
		mounted: function(){
			if(this.r_messages && this.r_messages["title"]){
				document.title = this.r_messages["title"];
console.log("title : " + document.title);
			}
			this.createDispItem();

			// メニューを閉じる処理をバインドする
			$("body").on("click", function(){
				if($(".sub-menu-display").length > 0){
					this.changeStableDisp(this.m_strDispStable, true);
				}
			}.bind(this))
			$("body").on("keydown", function(e){
				if(e.keyCode === 9 && $(".sub-menu-display").length > 0){
					this.changeStableDisp(this.m_strDispStable, true);
				}
			}.bind(this))
		},
		computed:{
			url_menu:function(){
				return "./home";//this.path_to_home + "./home";
			},
			url_select_company:function(){
				return this.url_root + "select-comapny";
			},
			url_help:function(){
				return this.r_settings["help_url"];
			},
			is_smart_phone:function(){
				if(this.r_settings){
					return this.r_settings["is_smart_phone"]?true:false;
				}
				return false;
			},
			user_settings:function(){
				let obj = $.extend(true,{},this.r_settings);
				obj['edit_right'] = true;
				return obj;
			},
			user_messages:function(){
				let obj = $.extend(true,{},this.r_messages);
				obj.title = obj.user_title;
				return obj;
			},
			target_blank:function(){
				return "_blank";
			},
			is_change_language_target: function() {
				var result = false;
				if (this.r_settings.user.user_type_code == USER_TYPE.DIGI) {
          result = true;
        } else {
          switch (this.r_settings.user.language) {
            case 'English':
              result = false;
              break;
            default:
              result = true;
              break;
          }
        }
				return result;
			},
		},
		methods: {
			// style設定
			setElementStyle: function(type) {
				var result = '';

				if (type == 'logging_in') {
					if (this.is_change_language_target) {
						result = 'cursor:pointer;';
					}
				}

				return result;
			},
			// 管理会社
			dispSellerName: function(val) {
				var result = (val) ? val : '－';
				return result;
			},
			// ディーラー
			dispDealerName: function(val) {
				var result = (val) ? val : '－';
				return result;
			},
			onEvent:function(name){
				console.log("onEvent - " + name);
			},
			onClickMenu:function(name){
				if(!this.is_smart_phone){
					this.changeStableDisp(name,true);
				}
			},
			onMenuFocusIn(name){
console.log("onMenuFocusIn");				
				//this.changeStableDisp(name,true);
			},
			onMenuFocusOut(name){
console.log("onMenuFocusOut");
				if(!this.is_smart_phone){				
					this.changeStableDisp(name,false);
				}
			},
			//! 固定表示切替
			changeStableDisp:function(name, on){
				var date = new Date();
				if(this.m_bDispStable)
				{// 固定表示中
					if(on){
						if( name == this.m_strDispStable){// 同じアイテムがクリックされたら無効化
							
							if( this.m_timeStableStart == null ||
								Math.abs(date.getTime() - this.m_timeStableStart) > 100){
							// 有効化後100msecは操作を受け付けない
								this.m_bDispStable = false;
								this.m_strDispStable = "";
								this.m_timeStableStart=null;
							}
						}
						else{// 切り替え
							this.m_strDispStable = name;
							this.m_timeStableStart = date.getTime();
						}
					}else{
						this.m_bDispStable = false;
						this.m_strDispStable = "";
						this.m_timeStableStart=null;
					}
				}else{// 無効状態からクリックの場合は有効化
					this.m_bDispStable = true;
					this.m_strDispStable = name;
					this.m_timeStableStart = date.getTime();
				}
console.log(" [ changeStableDisp ] end title=" + name + " , stable=" + this.m_bDispStable +" , target=" +  this.m_strDispStable);
			},
			createDispItem: function(){
				this.m_objDisp = {};
				this.m_objDisp = $.extend(true,{},this.r_header);
				for( var key in this.r_header )
				{
					var menu =  $.extend(true,{},this.r_header[key]);
					var dest = this.m_objDisp[key];
					dest.list = [];

					for( var subkey in menu.list ){
						var submenu = menu.list[subkey]; 

						if(submenu.type!="item"){// カテゴリ

							var arrTemp = null;
							if(submenu.list && submenu.list.length > 10){
								arrTemp = submenu.list.slice(10);
								submenu.list.splice(10);
							}
							dest.list.push(submenu);
							while(arrTemp){
								var addmenu = {"title":"",type:"category",list:arrTemp};
								if(arrTemp.length > 10){
									var temp = arrTemp.slice(10);	//!< 切り出し
									arrTemp.splice(10);			//!< 削除
									addmenu.list = arrTemp;
									dest.list.push(addmenu);
									
									arrTemp = temp;
								}else{
									dest.list.push(addmenu);
									arrTemp = null;
								}
							}
						}else{
							dest.list.push(submenu);
						}
					}
				}
				console.log("[ createDispItem ]");
				console.log(this.r_header);
				console.log(this.m_objDisp);
			},
			addMenuItemClass : function(menu, title){
				// サブカテゴリーチェック
				// 各メインカテゴリー内のサブカテゴリーが1つでも存在する場合はtrue
				var isSubCategory = false;
				if (menu.list) {
					$.each(menu.list, function(i, row) {
						// サブカテゴリー名判定
						if (String(row.title).length > 0) {
							isSubCategory = true;
							return false;
						}
					});
				}

				// サブカテゴリーあり
				if (isSubCategory) {
					if (title && title.length) {
						return "";
					}
					return "blank-category";
				// サブカテゴリーなし
				} else {
					return "";
				}
			},
			getRootPath:function(path){
				return this.path_to_home + path; 
			},
			//! 設定パラメータ変更イベント
			onLoadSetting : function(){
				console.log("[ Header - onLoadSetting ]");
				console.log(this.setting_param);
			},
			//! Homeかどうか
			getMenuClass : function(menu){
				if(menu.url != "" && menu.url != undefined){
					return "home";
				}
				if(this.isUsedSubMenu(menu)){
					return "sub-menu";
				}
				return "disable";
			},
			/**
			 * class取得(for input)
			 */
			getAddInputClass: function(type, info) {
				var result = '';

				switch (type) {
					// ユーザーID
					case 'user_id':
						if (info.admin_cl == 1) {
							if (info.user_type_code == USER_TYPE.DIGI) {
								result = 'text_color_admin_digi';
							} else if (info.user_type_code == USER_TYPE.SELLER) {
								result = 'text_color_admin_seller';
							} else if (info.user_type_code == USER_TYPE.DEALER) {
								result = 'text_color_admin_dealer';
							}
						}
						break;
					// その他
					default:
						break;
				}

				return result;
			},
			//! 画面左端から表示できるように、相対位置を計算する。
			getMenuLeft : function( key ){
				var index = Object.keys(this.m_objDisp).indexOf(key);
				if(index){
					return  "-" + index + "00%";
				}
				return "0";
			},
			onMenuClick:function(menu){
				this.changeStableDisp(menu.title,true);
			},
			getMenuWidth : function(){
				return Object.keys(this.m_objDisp).length  + "00%";
			},
			//! リンクジャンプ
			onJump: function(url) {
				console.log(" >>> onJump : " + url);

				// 修正ここから
				var tmpUrl = url.split('/')[1];

				if (tmpUrl == DISPLAY_URL.DIGI_ACCOUNT) {
					var userTypeCode = this.r_settings.user.user_type_code;
					switch (userTypeCode) {
						case USER_TYPE.SELLER:
							tmpUrl = "./" + DISPLAY_URL.SELLER_ACCOUNT;
							break;
						case USER_TYPE.DEALER:
							tmpUrl = "./" + DISPLAY_URL.DEALER_ACCOUNT;
							break;
						default:
							tmpUrl = url;
					}
				} else {
					tmpUrl = url;
				}
				// ここまで

				var baseHref = $('base').attr('href');
				if ( baseHref ) {

				} else {
					baseHref = "";
				}
				console.log(this.manager);
				if (this.manager) {
					this.manager.callPreJumpCallback(
						function() {
							window.location.href = baseHref + tmpUrl;
						},
						function() {
							console.log("jump cancel.");
						}
					)
				} else {
					window.location.href = baseHref + tmpUrl;
				}
			},
			//! ヘルプ
			onOpenPage:function(url){
				console.log(" >>> onJump : " + url);
				window.open(url, '_blank');
			},
			//! ログアウト
			onLogout:function(e){
				e.preventDefault();
				if(this.manager){
					this.manager.callPreJumpCallback(function(){document.getElementById('logout-form').submit();},
														function(){console.log("logout cancel.");})
				}
				else{
					document.getElementById('logout-form').submit();
				}
			},
			onBtnSelect: function(){
				this.m_selectCompany = true;
			},
			onButClose: function(e) {
				this.m_selectCompany = false;
			},
			//! ユーザー選択
			onBtnUserSelect: function(){
				this.setUser();
			},
			//! ユーザー画面クローズ
			onBtnUserClose: function(){
				this.m_selectUser = false;
			},
			onChangeCompany: function(info){
				if(this.manager){
					this.manager.callPreJumpCallback(
						function(){ 
							this.setCompany(info);
						}.bind(this),
						function(){
							console.log("jump cancel.");
						}.bind(this)
					)
				}else{
						this.setCompany(info);
				}
			},
			setCompany: function(info){
				var url = "api/header/company";
				var data = {"company_code":Number(info.company_code),
							"company_name":info.company_name};
				var target = this;
				var callbackOK = function(rResponse){
					console.log("setCompany success : ");
					console.log(rResponse);
					// 企業変更
					this.m_nCompanyName = info.company_name;
					this.m_nCompanyCode = Number(info.company_code);

					window.location.reload();
					// 画面再表示の処理
				}.bind(this);
				var callbackNG = function(rResponse){
					console.log("setCompany success error! :");
					console.log(rResponse);
				}
				this.manager.post(url,data,callbackOK,callbackNG);
			},

			/**
			 * ユーザーを設定
			 */
			setUser: function(){
				var url = "api/user/search-next";
				var data = {
					"company_code":this.r_settings.user.is_client == 1 ? Number(this.m_nCompanyCode) : 0,
					"direction":0,
					"call_code":this.r_settings.user.user_id,
				};
				var target = this;
				var callbackOK = function(rResponse){
					console.log("setUser success : ");
					console.log(rResponse);
					let result = rResponse.data;
					if(result.result == 0 && result.allcount >= 1) {
						this.m_userInfo = result.rec[0];
						this.m_selectUser = true;
					} else {
						this.m_selectUser = false;
					}
					// 画面再表示の処理
				}.bind(this);
				var callbackNG = function(rResponse){
					console.log("setUser success error! :");
					console.log(rResponse);
					this.m_selectUser = false;
				}.bind(this);
				console.log("setUser access :");
				console.log(data);
				this.manager.access2(url,data,callbackOK,callbackNG);
			},
			//! サブメニューが使えるかどうか
			isUsedSubMenu: function(menu){
				return menu.list && menu.list.length > 0 && menu.enable==true;
			},
      // 表示言語変更
      changeDispLanguage: function() {
        if (this.is_change_language_target) {
          var url = "api/header/change_disp_language";
          var data = {};
          var target = this;
          var callbackOK = function(rResponse){
            console.log("changeDispLanguage success : ");
            console.log(rResponse);

						if (rResponse.data.result == 0) {
							window.location.reload();
						}
            // 画面再表示の処理
          }.bind(this);
          var callbackNG = function(rResponse){
            console.log("changeDispLanguage success error! :");
            console.log(rResponse);
          }
          this.manager.post(url,data,callbackOK,callbackNG);
        }
			},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/Header.vue